<template>
  <div>
     <div
        v-if="loader"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout class="index_header table_opacity_8">
        <!-- <v-flex xs12 md6 class="ml-0" justify-space-around>
          <v-autocomplete
            v-model="filters.station"
            :items="local_stations"
            prepend-icon="mdi-database-search"
            placeholder="Search By Station Name"
            :search-input.sync="search_title"
            item-value="id"
            item-text="name"
            clearable
            @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex> -->
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-menu offset-y>
            <v-btn
              slot="activator"
              color="rgb(248 71 6)"
              class="white--text add_notification"
            >
              <router-link to="/create-contact" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon
                >Create Contact</router-link
              >
            </v-btn>
          </v-menu>
        </v-flex>

      </v-layout>

        <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the Contact Details?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

       <v-dialog
          v-model="edit_dialog"
          scrollable
          :overlay="false"
          max-width="500px"
          max-height="800px"
          transition="dialog-transition"
      >
        <v-card>
          <v-form
              @submit.prevent="validateBeforeSubmit('updateContactDetails')"
              data-vv-scope="updateContactDetails"
              ref="form"
              v-model="valid"
          >
            <v-card-text>
              <v-card-title primary-title>
                <span class="headline"></span>
              </v-card-title>
              <v-container fluid grid-list-md style="padding: 0 16px 16px 16px">
                <v-layout row wrap>
                    <v-flex xs12>
                      <v-autocomplete
                        label="Select Contact Category"
                        name="Category"
                        :items="contact_category"
                        v-model="contact_details_object.category_id"
                        return-object
                        item-text="name"
                        item-value="id"
                        selected
                        clearable
                      >
                      </v-autocomplete>
                    </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="title"
                        label="Title"
                        v-model="contact_details_object.title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="description"
                        label="Description"
                        v-model="contact_details_object.description"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="contact_info"
                        label="Contact Info"
                        v-model="contact_details_object.contact_info"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="ref_link"
                        label="Ref Link"
                        v-model="contact_details_object.ref_links"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit">Submit</v-btn>
              <v-btn small flat @click="edit_dialog = !edit_dialog">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-data-table
        no-results-text="Loading... Please wait"
        :headers="headers"
        :items="contact_list"
        :pagination.sync="pagination"
        :loading="loaders.contact_list_loader"
        :total-items="total_items"
        :rows-per-page-items="[10, 20, 50, 100]"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              style="width: 27%"
              v-for="header in props.headers"
              :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">

          <td v-if="props.item.category">{{ props.item.category.name}}</td>
          <td v-else>{{" - "}}</td>

          <td v-if="props.item.title">{{ props.item.title }}</td>
          <td v-else>{{" - "}}</td>

          <td v-if="props.item.description">{{ props.item.description}}</td>
          <td v-else>{{" - "}}</td>
          
          <td v-if="props.item.contact_info" style="width: 30px">{{ props.item.contact_info}}</td>
          <td v-else>{{" - "}}</td>

          <td v-if="props.item.ref_links">{{ props.item.ref_links}}</td>
          <td v-else>{{" - "}}</td>

          <td v-if="props.item.updated_at">{{ props.item.updated_at | appDateTimeFormat}}</td>
          <td v-else>{{" - "}}</td>

          <td class='pa-1'>
             <v-layout row wrap>
                <v-btn small color="primary" class="white--text elevation-5" @click="contactDetails(props.item)">Edit</v-btn>
                <v-btn small color="#F84706" class="white--text elevation-5" @click="contactDelete(props.item.id)">Delete</v-btn>
            </v-layout>
          </td>
        
        </template>
        <template slot="no-data">
          <v-layout
            row
            wrap
            justify-center
            class="text-xs-center"
            v-if="loaders.contact_list_loader"
          >
            Loading... Please wait
          </v-layout>
          <v-layout row wrap justify-center class="text-xs-center" v-else>
            No data available
          </v-layout>
        </template>
      </v-data-table>
       <v-snackbar
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Index",
  data: () => {
    return {
      headers: [
        {
          text: "Contact Name",
          value: "contact_name",
          align: "left",
          sortable: false,
        },
        {
          text: "Title",
          value: "title",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          sortable: false,
        },
        {
          text: "Contact Info",
          value: "contact_info",
          sortable: false,
        },
         {
          text: "Ref Link",
          value: "ref_link",
          sortable: false,
        },
         {
          text: "Updated_at",
          value: "updated_at",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      Ecart_list:[],
      contact_list:[],
      ecart_details_object:{},
      contact_details_object:{},
      contact_category:[],
      loaders: {
        contact_list_loader: false,
      },
      station_ads_inventory_list: [],
      station_inventory_object:{},
      local_stations:[],
      api_type:"web",
      loader: false,
      total_items: 0,
      status: true,
      valid:false,
      edit_dialog:false,
      delete_model:false,
        read:true,
        snack_bar: {
        show: false,
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },  
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: { sortBy: "created_at", descending: false, rowsPerPage: 10 },
      filters: {
        station:"",
        title: "",
        Published: false,
        Draft: false,
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
   
    "filters.station": {
      handler(value) {
        if (value == undefined) {
          this.filters.station = "";
          this.getList();
        }
      },
    },
   
   
  },
 methods: {


     contactDelete: function(contact_id) {
        this.contact_details_object.contact_id = contact_id;
        this.delete_model = true;

     },

   
     confirmDelete: function () {
      this.loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-contact-detail`,
              { contact_id: this.contact_details_object.contact_id},
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.delete_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.getList();
            }
          })
          .catch((error) => {})
          .finally(() => {});
    },

      validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },

     contactDetails: function(contactDetail){
      this.contact_details_object = contactDetail;
      this.edit_dialog=true;
     },

     updateContactDetails: function(){
     this.loader =  true; 
     let new_contact_details = Object.assign({}, this.contact_details_object);
     // new_contact_details.category_id = this.contact_details_object.category_id.id;
     if(this.contact_details_object.category_id.id == undefined)
     {

       new_contact_details.categoryid = this.contact_details_object.category_id;

     }else{

        new_contact_details.categoryid = this.contact_details_object.category_id.id;

     }
     
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-emergency-contact`, new_contact_details,{ headers: this.$headers }).then((response)=>{
        if(response.data.status == 1)
        {

          this.edit_dialog=false;
          this.loader=false;
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
          this.getList();
          // this.$router.push({name:"StationAdsInventoryList"});  
        }
        else
        {
          this.loader =  true;
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
        }

      }).catch((error)=>{
        this.loader =  true;
        console.log(error);
      }).finally(()=>{
        this.loader =  false;
      });  
     },

    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
              
                this.local_stations = response.data.stations;
                   
             }  
        })
    },

    filter(e) {
      this.filters.Published = false;
      this.filters.Draft = e;

      this.getList();
    },
    filterPublished(e) {
      this.filters.Draft = false;
      this.filters.Published = e;
      this.getList();
    },
    searchByTitle() {
      this.getList();
    },
    getList: function () {
      this.loaders.contact_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/emergency-contacts`, {
          headers: this.$headers,
          params: {'params':this.pagination},
        })
        .then((response) => {
          if (response.data.status == 1) {

            this.contact_list = response.data.emergency_contacts;            
            
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.contact_list_loader = false;
          }
        });
      this.is_loading = false;
    },
    getTitlesList: function (newVal) {
      this.loaders.contact_list_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
          { headers: this.$headers, params: { searched_title: newVal } }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.title_list = response.data.titles;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.contact_list_loader = false;
          }
        });
      this.is_loading = false;
    },
     getContactCategory: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/emergency-contact-category`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.contact_category = response.data.contact_category;
             }  
        })
    },
  },
  mounted() {
    this.getList();
    this.getStations();
    this.getContactCategory();
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}

</style>

